import { EventEmitter, InjectionToken } from '@angular/core';

export interface UnitClickableComponent {
    unitClick: EventEmitter<void>;
}

export const UNIT_CLICKABLE = new InjectionToken<UnitClickableComponent>('UnitClickableComponent');
